import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import Countdown from '../Countdown'
import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang, giftDataImg } = this.props
    return (
      <div className="top">
        <div style={{ height: '6.5rem' }}></div>
        {/* <div className="time">2020.12.15-2020.12.19</div> */}
        {/* <div className="title">{lang.title}</div> */}
        <div className="bd">
          <div className="des">
            <div style={{ height: '2rem' }}>
              {/* <Countdown language={language} lang={this.state.lang} remaintime={remaintime} now={now} /> */}

            </div>

            <div className="ruby-monopoly-gift">
              <p>
                RUBY Gift
              </p>
              <div className="ruby-monopoly-conten">
                <div className="ruby-monopoly-conten-img">
                  <img src={giftDataImg.image} />
                </div>
                <p>{giftDataImg.name}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/Top/index.js